<template>
  <v-layout align-center>
    <v-flex class="text-xs-left font-weight-light">
      <span :class="['feature-name', feature.color]">{{ feature.name }}</span>
    </v-flex>
    <v-spacer/>
    <!-- A switch to load the items already tagged with this feature -->
    <v-features-list-item-checkbox-tagged :feature="feature" />
    <!-- A button to remove the feature with a confirmation dialog -->
    <v-features-list-item-remove :feature="feature" />
  </v-layout>
</template>

<script>
import VFeaturesListItemRemove from "./FeaturesListItemRemove";
import VFeaturesListItemCheckboxTagged from "./FeaturesListItemCheckboxTagged";

export default {
  components: {
    VFeaturesListItemRemove,
    VFeaturesListItemCheckboxTagged
  },
  props: {
    /**
     * The feature to show in the hader.
     */
    feature: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.feature-name {
  padding: 3px 5px;
  border-radius: 2px;
}
</style>
